import { render, staticRenderFns } from "./ModalFixProductQuantity.vue?vue&type=template&id=64f63e5a&scoped=true"
import script from "./ModalFixProductQuantity.vue?vue&type=script&lang=js"
export * from "./ModalFixProductQuantity.vue?vue&type=script&lang=js"
import style0 from "./ModalFixProductQuantity.vue?vue&type=style&index=0&id=64f63e5a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f63e5a",
  null
  
)

export default component.exports